import { Grid, SxProps } from '@mui/material';
import _ from 'lodash';
import { ReactNode } from 'react';
import { GameTheme } from '../../config/GameTheme';
import { muiStyleSheet } from '../../util/Styles';

type Props<T> = {
	items: T[],
	renderItem: (item: T, index: number) => ReactNode;
	sx?: SxProps<typeof GameTheme>;
};

export const TwoColumns = <T,>(props: Props<T>): ReactNode => {
	const { items } = props;
	const rows = Math.floor((items.length + 1) / 2);

	return <Grid container columns={2} columnSpacing={6} sx={props.sx}>
		{_.times(rows).map((_, rowId) => {
			const firstId = rowId;
			const secondId = firstId + rows;

			return [
				<Grid key={`item${firstId}`} size={1} sx={styles.row}>{props.renderItem(items.getSafe(firstId), firstId)}</Grid>,
				(secondId < items.length) &&
				<Grid key={`item${secondId}`} size={1} sx={styles.row}>{props.renderItem(items.getSafe(secondId), secondId)}</Grid>,
			];
		})}
	</Grid>;
};


const styles = muiStyleSheet({
	container: {
		// height: '100%',
		alignContent: 'space-between',
	},
	row: {
		display: 'flex',
		alignItems: 'center',
	},
});
